var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomebuyer42(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 51,
    viewBox: "0 0 45 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.68 0.737366H19.44C8.72 0.737366 0 9.34727 0 19.9319V28.318C0 40.3376 9.89333 50.1061 22.0667 50.1061C34.24 50.1061 44.1333 40.3376 44.1333 28.318V19.9319C44.12 9.36043 35.4 0.737366 24.68 0.737366ZM39.32 28.3312C39.32 37.731 31.5733 45.3798 22.0533 45.3798C12.5333 45.3798 4.78667 37.731 4.78667 28.3312V25.0136C8.32 24.9873 16.9733 24.1184 22.0533 16.6407C27.1333 24.1184 35.7867 25.0004 39.32 25.0136V28.3312ZM39.32 20.2742C36.5333 20.2479 29.24 19.537 25.5333 13.1914C24.8 11.9408 23.5067 11.1904 22.0533 11.1904C20.6 11.1904 19.3067 11.9408 18.5733 13.1914C14.84 19.5765 7.58667 20.261 4.78667 20.2742V19.9319C4.78667 11.9539 11.36 5.47676 19.4267 5.47676H24.6667C32.7467 5.47676 39.3067 11.9671 39.3067 19.9319L39.32 20.2742ZM16.32 29.7267C16.32 31.267 15.0533 32.5308 13.48 32.5308C11.9067 32.5308 10.64 31.2801 10.64 29.7267C10.64 28.1864 11.9067 26.9225 13.48 26.9225C15.0533 26.9225 16.32 28.1732 16.32 29.7267ZM27.7867 29.7267C27.7867 28.1864 29.0533 26.9225 30.6267 26.9225C32.2 26.9225 33.4667 28.1732 33.4667 29.7267C33.4667 31.267 32.2 32.5308 30.6267 32.5308C29.0533 32.5308 27.7867 31.267 27.7867 29.7267Z",
    fill: "#004282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomebuyer42);
export default __webpack_public_path__ + "static/media/homebuyer4-2.8e14c527dcd288b59d966443e674c148.svg";
export { ForwardRef as ReactComponent };